import { render, staticRenderFns } from "./Modulos.vue?vue&type=template&id=27b4a0b7&"
import script from "./Modulos.vue?vue&type=script&lang=ts&"
export * from "./Modulos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('27b4a0b7', component.options)
    } else {
      api.reload('27b4a0b7', component.options)
    }
    module.hot.accept("./Modulos.vue?vue&type=template&id=27b4a0b7&", function () {
      api.rerender('27b4a0b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administracion/Modulos.vue"
export default component.exports